import type { Event } from '@patsnap/tahiti-core/common/event';
import type { QueryHighlight } from '../types';

export const QueryHighlightService = Symbol.for('QueryHighlightService');

export interface QueryHighlightService {
    readonly onStatesChange: Event<QueryHighlight>;

    getModelData(): QueryHighlight;
    updateQueryHighlight(queryHighlight: QueryHighlight): void;
}
